module.exports = __webpack_public_path__ + "static/media/40 - Carly Simon - Why.abbff690.mp3";